import { ReactNode, MouseEvent, memo, useState, useEffect } from 'react';
import { Span } from '../../../../../../component/modal/ModalStyle';
import Modal from '../../../../../../component/modal/Modal.component'
import Button from '../../../../../../component/buttton/Button.component';
import GridComponent from "../../../../../../component/grid/GridComponent.component";
import MenuItem from '@material-ui/core/MenuItem';
import { FormInput, FormSelect } from '../../../../../../component/input/InputStyle';
import { Grid } from '@material-ui/core';
import FormLabel from '../../../../../../component/input/FormLabel.component';
import { InterfaceStore, TypeVehicleInterface } from '../../interface/InterfaceStore';


interface Props {
  children?: ReactNode;
  open: boolean;
  onClickSubmit(newStore: string, newTimeStart: string, newTimeEnd: string, newIdTruck: string, newIdModal: string): void;
  title: string;
  data: InterfaceStore;
  labelTruck: TypeVehicleInterface[];
  handleClick(event: MouseEvent<HTMLElement>): void
}



function ModalUpdate({ open, title, onClickSubmit, data, labelTruck, handleClick }: Props) {

  const [valueStoreModal, setValueStoreModal] = useState('');
  const [valueTruckModal, setValueTruckModal] = useState('');
  const [valueTimeStartModal, setValueTimeStartModal] = useState('');
  const [valueTimeEndModal, setValueTimeEndModal] = useState('');
  const [idTruckModal, setIdTruckModal] = useState<any>('');
  const [idModal, setIdModal] = useState<any>('')

  const handleChange = (event: any) => {
    const { value, name } = event.target
    if (name === 'loja') {
      setValueStoreModal(value);
    } else if (name === 'tipoVeiculo') {
      const typeWalkIdModal = labelTruck.filter((item: TypeVehicleInterface) => {
        return value === item.tipoVeiculo;
      });
      setIdTruckModal(typeWalkIdModal[0].id);
      setValueTruckModal(value);
    } else if (name === 'horarioInicio') {
      setValueTimeStartModal(value);
    } else {
      setValueTimeEndModal(value);
    }
  }

  useEffect(() => {
    const typeWalkIdModal = labelTruck.filter((item: TypeVehicleInterface) => {
      return data.tipoVeiculo === item.tipoVeiculo;
    });
    setValueStoreModal(data.destino);
    setValueTruckModal(data.tipoVeiculo);
    setValueTimeStartModal(data.horarioInicio);
    setValueTimeEndModal(data.horarioFim);
    setIdModal(data.ID)
    setIdTruckModal(typeWalkIdModal[0].id)
  }, [open]);

  return (
    <Modal size={'xl'} open={open} handleClick={() => { }} >
      <Span style={{ textAlign: "center" }}>{title.toLocaleUpperCase()}</Span>
      <GridComponent margin="10px auto 10px auto" spacing={2}>
        <FormLabel title='Loja' sm={12} md={6} lg={3}>
          <FormInput value={valueStoreModal} name="loja" onChange={handleChange} />
        </FormLabel>
        <FormLabel title='Tipo de caminhão' sm={12} md={6} lg={3}>
          <FormSelect value={valueTruckModal} name="tipoVeiculo" onChange={handleChange} displayEmpty={true} defaultValue={valueTruckModal}>
            <MenuItem disabled value="">Selecione o tipo</MenuItem>
            {labelTruck.map((item: TypeVehicleInterface, index: number) => (
              <MenuItem key={index} value={item.tipoVeiculo}>{item.tipoVeiculo}</MenuItem>
            ))}
          </FormSelect>
        </FormLabel>
        <FormLabel title="Horário Início" sm={12} md={6} lg={3}>
          <FormInput type="time" value={valueTimeStartModal} name="horarioInicio" onChange={handleChange} />
        </FormLabel>
        <FormLabel title="Horário Fim" sm={12} md={6} lg={3}>
          <FormInput type="time" value={valueTimeEndModal} name="horarioFim" onChange={handleChange} />
        </FormLabel>
        <Grid item margin="0 auto" xs={6}>
          <Button title='Ok' size='small' onClick={() => onClickSubmit(valueStoreModal, valueTimeStartModal, valueTimeEndModal, idTruckModal, idModal)} fullWidth />
        </Grid>
        <Grid item margin="0 auto" xs={6}>
          <Button title='Fechar' size='small' onClick={handleClick} fullWidth />
        </Grid>
      </GridComponent>
    </Modal>
  );
}

export default memo(ModalUpdate);
